import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';
import Organization from '@/types/organizationType';
import User from '@/types/userType';

const endPoint = 'billing/getCheckoutUrl';
const url = apiUrl + endPoint;

const getStripeCheckoutUrl = async (
  org: Organization,
  admin: User,
  headerObj: headerObject,
  billingInterval: string = 'month'
) => {
  try {
    const res = await postWithAuth(
      url,
      {
        OrganizationUUID: org.OrgUUID,
        OrganizationName: org.OrgName,
        AdminEmail: admin.Email,
        BillingInterval: billingInterval,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    return JSON.parse(text);
  } catch (err) {
    console.error(err);
  }
};

export default getStripeCheckoutUrl;
